<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{
            !permissaoEditar
              ? "Visualizar"
              : mostrarIniciativas
              ? ""
              : id > 0
              ? "Editar"
              : "Adicionar"
          }}
          Territórios
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Nome"
              name="tipo"
              type="text"
              v-model="territorio.nome"
              required
              :rules="rules"
              background-color="white"
              @blur="changeNomeFantasia"
              :disabled="!permissaoEditar || mostrarIniciativas"
            />
          </v-col>

          <v-col>
            <v-text-field
              v-model="territorio.inicio"
              v-mascara="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
              :rules="rulesData"
              :disabled="!permissaoEditar || mostrarIniciativas"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="territorio.nomeFantasia"
              label="Nome Fantasia"
              :disabled="!permissaoEditar || mostrarIniciativas"
            ></v-text-field>
          </v-col>

          <v-col>
            <ComboboxTerritoriosStatusTerritorio
              :value="territorio"
              :disabled="!permissaoEditar || mostrarIniciativas"
            ></ComboboxTerritoriosStatusTerritorio>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <combobox-municipio-territorio
              :value="territorio"
              :multiple="true"
              :clearable="true"
              :disabled="!permissaoEditar || mostrarIniciativas"
              :mostrarMunicipios="!permissaoEditar"
            ></combobox-municipio-territorio>
          </v-col>
        </v-row>

        <template v-if="mostrarIniciativas">
          <v-row>
            <v-col>
              <h2 class="w-100 text-center title-insert">Iniciativas</h2>
            </v-col>
          </v-row>
          <v-row v-if="permissaoAdicionarIniciativa">
            <v-col class="d-flex">
              <div class="addIniciativa">
                <modal-adicionar-iniciativa
                  :dialog="showModalAddIniciativa"
                  :title="'Adicionar Iniciativas'"
                  @onSave="addIniciativa"
                  :iniciativasSelecionadas="territorio.territoriosIniciativas"
                  :territorioId="id"
                ></modal-adicionar-iniciativa>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="permissaoEditar">
            <v-col class="delete">
              <v-btn
                outlined
                color="error"
                class="mr-3"
                :disabled="
                  !permissaoEditarIniciativa ||
                  !territorio.territoriosIniciativas.length
                "
                @click="removeAllPermission()"
              >
                <v-icon>mdi-trash-can-outline</v-icon> Deletar Todos
              </v-btn>
              <v-btn
                color="error"
                class="mr-3"
                :disabled="!selectionItems.length"
                @click="removePermission()"
              >
                <v-icon>mdi-trash-can-outline</v-icon> Deletar Selecionados
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            style="
              row-gap: 15px;
              column-gap: 15px;
              justify-content: space-around;
              margin-bottom: 10px;
            "
          >
            <v-col v-if="!territorio.territorioIniciativaFiltrado.length">
              Nenhuma Iniciativa
            </v-col>
            <template v-else>
              <v-col>
                <v-data-table
                  :headers="headersIniciativas"
                  :items="territorio.territorioIniciativaFiltrado"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                  :search="search"
                >
                  <template slot="no-data">
                    <span> Nenhuma Iniciativa </span>
                  </template>

                  <template v-slot:item.selection="{ item, index }">
                    <v-checkbox
                      color="primary"
                      v-model="item.selection"
                      @change="
                        territorio.territoriosIniciativas =
                          territorio.territoriosIniciativas.map((item, i) => {
                            if (index === i) {
                              item.selection = $event;
                            }
                            return item;
                          })
                      "
                      :disabled="!permissaoEditarIniciativa"
                    >
                    </v-checkbox>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <modal-adicionar-iniciativa
                      v-if="permissaoVisualizarIniciativa"
                      :dialog="showModalAddIniciativa"
                      :title="'Visualizar Iniciativa'"
                      @onSave="addIniciativa"
                      :iniciativa="item"
                      :readonly="true"
                      :territorioId="id"
                    ></modal-adicionar-iniciativa>
                    <modal-adicionar-iniciativa
                      v-if="permissaoEditarIniciativa"
                      :dialog="showModalAddIniciativa"
                      :title="'Editar Iniciativa'"
                      @onSave="addIniciativa"
                      :iniciativa="item"
                      :territorioId="id"
                    ></modal-adicionar-iniciativa>
                  </template>
                </v-data-table>
              </v-col>
            </template>
          </v-row>
        </template>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            {{ permissaoEditar ? "Cancelar" : "Voltar" }}
          </v-btn>
          <v-btn v-if="permitirFinalizar" color="primary" type="submit">
            Finalizar
          </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxMunicipioTerritorio from "@/modules/gestao-territorios/components/territorios/ComboboxMunicipioTerritorios";
import ModalAdicionarIniciativa from "@/modules/gestao-territorios/components/territorios/ModalAdicionarIniciativa";
import ComboboxTerritoriosCategorias from "@/modules/gestao-territorios/components/categorias/ComboboxTerritoriosCategorias";
import moment from "moment";
import { territorioAPI } from "@/modules/gestao-territorios/API/territorioAPI";
import { dataRegexValidatior } from "@/helpers/validator";
import ComboboxTerritoriosStatus from "@/modules/gestao-territorios/components/status/ComboboxTerritorioIniciativaStatus";
import ComboboxTerritoriosStatusTerritorio from "@/modules/gestao-territorios/components/status/ComboboxTerritoriosStatus";

import { required, requiredBoolean } from "@/helpers/validator";
import ComboboxTerritoriosReponsaveis from "../responsaveis/ComboboxTerritoriosReponsaveis.vue";
import Swal from "sweetalert2";

export default {
  components: {
    ComboboxMunicipioTerritorio,
    ModalAdicionarIniciativa,
    ComboboxTerritoriosCategorias,
    ComboboxTerritoriosStatus,
    ComboboxTerritoriosReponsaveis,
    ComboboxTerritoriosStatusTerritorio,
  },
  props: {
    mostrarIniciativas: false,
  },
  data() {
    return {
      territorio: {
        territoriosIniciativas: [],
        territorioIniciativaFiltrado: [],
      },
      headersIniciativas: [
        { text: "", value: "selection" },

        { text: "Iniciativa", value: "nomeIniciativa" },
        { text: "Ações", value: "actions" },
      ],
      headers: [
        { text: "", value: "selection" },
        { text: "Eixo", value: "nomeEixo" },
        { text: "Iniciativa", value: "nomeIniciativa" },
        { text: "Datas", value: "date" },
        { text: "Ação", value: "action", width: "10%" },
      ],
      isEdit: false,
      allSelected: false,
      tabType: this.$route.params.tab,
      id: this.$route.params.id,
      action: this.$route.params.acao,
      rules: [(v) => !!v || "Campo Obrigatório"],
      required: required,
      requiredBoolean: requiredBoolean,
      rulesData: [
        (v) => {
          if (!v) return "Campo Obrigatório";
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
      rulesDataB: [
        (v) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
      showModalAddIniciativa: false,
      eixosFiltros: {},
      search: "",
      userTeste: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isGov", "config", "groupsConfig"]),

    selectionItems() {
      return this.territorio.territoriosIniciativas.filter(
        (item) => item.selection
      );
    },
    permitirFinalizar() {
      if (this.action === "view") return false;
      if (this.tabType === "iniciativas")
        return (
          this.permissaoEditarIniciativa || this.permissaoAdicionarIniciativa
        );
      if (this.id == 0) return this.permissaoAdicionarTerritorio;
      return this.permissaoEditar;
    },
    permissaoVisualizarIniciativa() {
      return (
        this.isFullAdmin ||
        (this.config.editarIniciativaTerritorio &&
          this.groupsConfig.editarIniciativaTerritorio)
      );
    },
    permissaoEditarIniciativa() {
      return (
        this.isFullAdmin ||
        (this.config.editarIniciativaTerritorio &&
          this.groupsConfig.editarIniciativaTerritorio)
      );
    },
    permissaoAdicionarIniciativa() {
      return (
        this.isFullAdmin ||
        (this.config.adicionarIniciativaTerritorio &&
          this.groupsConfig.adicionarIniciativaTerritorio)
      );
    },
    permissaoAdicionarTerritorio() {
      return (
        this.isFullAdmin ||
        (this.config.adicionarTerritorio &&
          this.groupsConfig.adicionarTerritorio)
      );
    },
    permissaoEditar() {
      if (this.action === "view") return false;
      if (this.id == 0) return this.permissaoAdicionarTerritorio;
      return (
        this.isFullAdmin ||
        (this.config.editarTerritorio && this.groupsConfig.editarTerritorio)
      );
    },
    notSelectionItems() {
      return this.territorio.territoriosIniciativas.filter(
        (item) => !item.selection
      );
    },
  },
  mounted() {
    if (this.id > 0) {
      this.setLoading(true);
      territorioAPI
        .get(this.id)
        .then(({ data }) => {
          var territoriosIniciativas = data.territoriosIniciativas;
          if (territoriosIniciativas && territoriosIniciativas.length) {
            territoriosIniciativas = territoriosIniciativas.map(
              (val, index) => {
                return {
                  ...val,
                  ...val.eixo,
                  ...val.iniciativa,
                  inicio: val.inicio
                    ? moment(val.inicio).format("DD/MM/YYYY")
                    : null,
                  fim: val.fim ? moment(val.fim).format("DD/MM/YYYY") : null,
                  territorioCategoria: val.territorioCategoriaId,
                  id: index,
                  responsaveis:
                    (val.responsaveisId &&
                      val.responsaveisId
                        .split(",")
                        .map((item) => parseInt(item))) ||
                    [],
                  statusId: val.statusIniciativaId,
                  municipioId: val.territorioIniciativasMunicipiosDTO.length
                    ? val.territorioIniciativasMunicipiosDTO.map(
                        (item) => item.municipioId
                      )
                    : [],
                };
              }
            );
          } else {
            territoriosIniciativas = [];
          }
          this.territorio = {
            municipioId:
              data.territoriosMunicipios &&
              data.territoriosMunicipios.length > 0
                ? data.territoriosMunicipios.map((item) => item.municipioid)
                : [],
            territorioIniciativaFiltrado: territoriosIniciativas,
            territoriosIniciativas: territoriosIniciativas,
            nome: data.nome,
            inicio: moment(data.inicio).format("DD/MM/YYYY"),
            nomeFantasia: data.nomeFantasia,
            statusId: data.statusId,
          };

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Territórios");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    changeNomeFantasia() {
      if (!this.territorio.nomeFantasia) {
        this.territorio.nomeFantasia = this.territorio.nome;
        this.$forceUpdate();
      }
    },
    changeEixo(id) {
      if (id.eixoId) {
        if (this.territorio.territorioIniciativaFiltrado.length > 0) {
          this.territorio.territorioIniciativaFiltrado =
            this.territorio.territorioIniciativaFiltrado
              .filter((item) => item.territorioEixoId == id.eixoId)
              .map((item) => ({ ...item, selection: false }));
        }
      } else {
        this.territorio.territorioIniciativaFiltrado =
          this.territorio.territoriosIniciativas;
      }
    },
    addIniciativa(val) {
      const indexExistente = this.territorio.territoriosIniciativas.findIndex(
        (item) => item.id == val.id
      );
      if (indexExistente > -1) {
        this.territorio.territoriosIniciativas.splice(indexExistente, 1, val);
      } else {
        this.territorio.territoriosIniciativas = [
          ...this.territorio.territoriosIniciativas,
          { ...val, id: this.territorio.territoriosIniciativas.length + 1 },
        ];
      }

      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;

      this.$forceUpdate();
    },
    goToList() {
      this.$router.push(`/gestao-territorios/${this.tabType}`);
    },
    removeAllPermission() {
      this.territorio.territoriosIniciativas = [];
      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;
    },
    removePermission() {
      this.territorio.territoriosIniciativas = this.notSelectionItems;
      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;
    },
    removeOnePermission(item) {
      this.territorio.territoriosIniciativas.forEach((val, index) => {
        if (item.territorioIniciativaId == val.territorioIniciativaId) {
          this.territorio.territoriosIniciativas.splice(index, 1);
        }
      });

      this.territorio.territorioIniciativaFiltrado.forEach((val, index) => {
        if (item.territorioIniciativaId == val.territorioIniciativaId) {
          this.territorio.territorioIniciativaFiltrado.splice(index, 1);
        }
      });
    },
    validateIniciativa() {
      let errors = [];
      this.territorio.territoriosIniciativas.forEach((item) => {
        if (
          moment(item.fim, "DD/MM/YYYY HH:mm").isBefore(
            moment(item.inicio, "DD/MM/YYYY HH:mm")
          )
        ) {
          errors.push(
            `<div style="margin-bottom:10px;"> ${item.nomeIniciativa} - Data final menor que data inicial</div>`
          );
        }
      });

      return errors;
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;

      if (
        this.territorio.territoriosIniciativas &&
        this.territorio.territoriosIniciativas.length > 0
      ) {
        if (this.validateIniciativa().length) {
          Swal.fire({
            title: "Iniciativa inválida",
            html: this.validateIniciativa(),
            confirmButtonText: "Ok",
          });

          return;
        }

        this.territorio.territoriosIniciativas =
          this.territorio.territoriosIniciativas.map((item) => ({
            ...item,
            inicio:
              (item.inicio &&
                moment(item.inicio, "DD/MM/YYYY").toISOString()) ||
              null,
            fim:
              (item.fim && moment(item.fim, "DD/MM/YYYY").toISOString()) ||
              null,
            usuarioId: this.userTeste.usuarioId,
            iniciativaId: item.territorioIniciativaId,
            statusIniciativaId: item.statusId,
            territorioCategoriaId: item.territorioCategoria,
            municipioId: item.municipioId || [],
            responsaveisId:
              (item.responsaveis &&
                item.responsaveis.length &&
                item.responsaveis.join(",")) ||
              null,
          }));
      }

      const territorio = {
        municipioId:
          this.territorio.municipioId && this.territorio.municipioId.length
            ? this.territorio.municipioId
            : null,
        nome: this.territorio.nome,
        inicio: moment(this.territorio.inicio, "DD/MM/YYYY").toISOString(),
        usuarioId: this.userTeste.usuarioId,
        territoriosIniciativas: this.territorio.territoriosIniciativas.length
          ? this.territorio.territoriosIniciativas
          : null,
        statusId: this.territorio.statusId,
        nomeFantasia: this.territorio.nomeFantasia,
        possuiIniciativas: this.mostrarIniciativas,
        uf: this.$store.state.uf,
      };
      this.setLoading(true);

      if (this.id > 0) {
        territorio.territorioId = parseInt(this.id);
        territorioAPI
          .update(territorio)
          .then(() => {
            if (this.mostrarIniciativas) {
              this.$notification.success("Iniciativa adicionada com sucesso!");
            } else {
              this.$notification.success("Território editado com sucesso!");
            }
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Território");
            console.log("Erro no submit ", err);
          });
      } else {
        territorioAPI
          .create(territorio)
          .then(() => {
            this.$notification.success("Território criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Território");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.addIniciativa {
  margin-left: auto;
}
.iniciativas {
  justify-content: center;
  align-items: center;
}
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
.dates {
  column-gap: 20px;
}
</style>
